// extracted by css-extract-rspack-plugin
export default {"optionsRoot":"NewModelOptions-module__optionsRoot___vKf44","educationalButton":"NewModelOptions-module__educationalButton___y124V"};